module.exports = __webpack_public_path__ + "img/skincare_entry.5eb33625.png";